export default {
  uhOh: 'O Ne!',
  nothingToEat: 'Atrodo, jog nepavyko rasti patiekalų!',
  alphabetical: 'Abėcėlė',
  price: 'Kaina',
  popularity: 'Populiarumas',
  select: 'Pasirinkti',
  orderBy: 'Rūšiuoti Pagal',
  youOrderedThisDish: 'Tu esi užsisakęs šį patiekalą',
  popularToday: 'Šis patiekalas šiandien populiarus!',
  notSavedYet: 'Dar neišsaugota',
  timeLeft: 'Likęs laikas:',
  days: '0 dienų | 1 diena | {count} dienos',
  successfullyOrdered: 'Sėkmingai užsakyta.',
  successfullyClearedOrder: 'Užsakymas sėkmingai išvalytas.',
  noMoreOrders: 'Užsakymai nebepriimami.',
  submitOrder: 'Išsaugoti užsakymą?',
  unsavedChanges: 'Buvo padaryta pakeitimų užsakymui, tačiau jie nebuvo išsaugoti. Ar išsaugoti šiuos pakeitimus?',
  addAdditional: 'Pridėti papildomą patiekalą',
  noMoreDishes: 'Atrodo, kad jau yra užtektinai patiekalų 😊.',
  orderForSomeoneElse: 'Redaguoti kito asmens užsakymą',
  modifyUserOrder: ' Užsakymų Redagavimas',
  searchByName: 'Paieška pagal vartotojo vardą',
  userNotFound: 'Vartotojas nerastas.',
  userSelections: 'Vartotojo pasirinkimai',
  cannotAddMoreThanOne: 'Nėra galimybės pridėti daugiau nei vieną tokį pasirinkimą.',
  addDish: 'Pridėti patiekalą',
  dishes: 'Patiekalai',
  limitedAmount: 'Šis patiekalas turi užsakymų limitą - {limit} vnt.',
  customOrderSuccessful: 'Užsakymas sėkmingai išsaugotas',
};
